import React from 'react';

import {
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText
} from '@mui/material';
import {
  BaseWidget,
  PermissionWall,
  routeDirectory
} from 'modules';
import {
  ImportExport,
  KeyboardReturn,
  LocalShipping,
  RequestPage,
  SupportAgent,
  Warehouse
} from '@mui/icons-material';



export const FC: React.FC = () => {
  return (
    <BaseWidget.FC title="Quick Routes">
      <List>
        <PermissionWall.FC requiresPermissions={['writeRequest_viewWriteRequest']}>
          <ListItem>
            <ListItemButton href={routeDirectory.admin.orderManagement.path('pendingWrites')}>
              <ListItemIcon>
                <RequestPage />
              </ListItemIcon>

              <ListItemText primary="Order Management" />
            </ListItemButton>
          </ListItem>
        </PermissionWall.FC>

        <PermissionWall.FC requiresPermissions={['inventory_viewInventoryLevels']}>
          <ListItem>
            <ListItemButton href={routeDirectory.admin.inventory.path('items')}>
              <ListItemIcon>
                <Warehouse />
              </ListItemIcon>

              <ListItemText primary="Inventory" />
            </ListItemButton>
          </ListItem>
        </PermissionWall.FC>

        <PermissionWall.FC requiresPermissions={['salesOrder_create']}>
          <ListItem>
            <ListItemButton href={routeDirectory.admin.thirdPartyLogistics.path()}>
              <ListItemIcon>
                <ImportExport />
              </ListItemIcon>

              <ListItemText primary="3PL Import" />
            </ListItemButton>
          </ListItem>
        </PermissionWall.FC>

        <ListItem>
          <ListItemButton href={routeDirectory.admin.returnAuthorizations_deprecated.path()}>
            <ListItemIcon>
              <KeyboardReturn />
            </ListItemIcon>

            <ListItemText primary="RMAs" />
          </ListItemButton>
        </ListItem>

        <PermissionWall.FC requiresPermissions={['thirdPartyAccount_viewThirdPartyAccounts']}>
          <ListItem>
            <ListItemButton href={routeDirectory.admin.thirdPartyAccounts.path()}>
              <ListItemIcon>
                <LocalShipping />
              </ListItemIcon>

              <ListItemText primary="Third Party Accounts" />
            </ListItemButton>
          </ListItem>
        </PermissionWall.FC>

        <PermissionWall.FC requiresPermissions={['customer_viewCustomer']}>
          <ListItem>
            <ListItemButton href={routeDirectory.admin.customers.path()}>
              <ListItemIcon>
                <SupportAgent />
              </ListItemIcon>

              <ListItemText primary="Customers" />
            </ListItemButton>
          </ListItem>
        </PermissionWall.FC>
      </List>
    </BaseWidget.FC>
  );
};
